<h3 mat-dialog-title>
    <strong>{{ title | translate }}</strong>
</h3>
<div fxLayout="column" style="flex-grow: 1; flex: 1; padding: 16px" fxLayoutAlign="start stretch" fxLayoutGap="8px">
    @if (information != '') {
        <div>
            <div style="font-size: 15px" [innerHTML]="information | safeHtml"></div>
        </div>
    }
    @if (subInformation != '') {
        <div>
            <pre style="padding-right: 2em">
        <div [innerHTML]="subInformation | safeHtml"></div>
      </pre>
        </div>
    }
    @if (template) {
        <ng-container [ngTemplateOutlet]="template"></ng-container>
    }
</div>

<mat-dialog-actions>
    <div fxLayout="row" fxLayoutAlign="end end" style="width: 100%">
        @if (button == 0) {
            <div>
                <button type="submit" matButton="tonal" class="secondary" (click)="onOk()" tabindex="-1">
                    {{ captions[0] | translate }}
                </button>
            </div>
        }
        @if (button == 1) {
            <div>
                <button type="submit" matButton="tonal" class="secondary" (click)="onOk()" tabindex="-1">
                    {{ captions[0] | translate }}
                </button>
                <button matButton="tonal" (click)="onCancel()" style="margin-left: 12px" tabindex="-1">
                    {{ captions[1] | translate }}
                </button>
            </div>
        }
        @if (button == 2) {
            <div>
                <button
                    type="submit"
                    matButton="tonal"
                    class="secondary"
                    style="margin-left: 12px"
                    (click)="onYes()"
                    tabindex="-1">
                    {{ captions[0] | translate }}
                </button>
                <button matButton="tonal" mat-dialog-close (click)="onNo()" tabindex="-1">
                    {{ captions[1] | translate }}
                </button>
            </div>
        }
        @if (button == 3) {
            <div>
                <button type="submit" matButton="tonal" class="secondary" (click)="onAccept()" tabindex="-1">
                    {{ captions[0] | translate }}
                </button>
                <button matButton="tonal" (click)="onReject()" style="margin-left: 12px" tabindex="-1">
                    {{ captions[1] | translate }}
                </button>
            </div>
        }
        @if (button == 4) {
            <div>
                <button
                    type="submit"
                    matButton="tonal"
                    class="secondary"
                    (click)="onYes()"
                    style="margin-left: 12px"
                    tabindex="-1">
                    {{ captions[0] | translate }}
                </button>
                <button matButton="tonal" mat-dialog-close (click)="onNo()" style="margin-left: 12px" tabindex="-1">
                    {{ captions[1] | translate }}
                </button>
                <button matButton="tonal" (click)="onCancel()" style="margin-left: 12px" tabindex="-1">
                    {{ captions[2] | translate }}
                </button>
            </div>
        }
    </div>
</mat-dialog-actions>
